import { combineReducers } from "redux";
import aboutDetailsReducer from "./about-details-fetch";

const reducers = combineReducers({ aboutDetailsReducer });

export default reducers;
